module.exports = __webpack_public_path__ + "static/media/IconFlagActive.56622176.svg";